import { useSsrAdapter as m } from "../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { configProviderInjectionKey as a } from "../config-provider/src/context.js";
import { cssrAnchorMetaName as l } from "./common.js";
import { exists as d } from "../../../../../css-render@0.15.14/node_modules/css-render/esm/exists.js";
import { computed as p, inject as v, onBeforeMount as R, watchEffect as S } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function A(o, i, f) {
  if (!i)
    return;
  const n = m(), s = p(() => {
    const {
      value: t
    } = i;
    if (!t)
      return;
    const e = t[o];
    if (e)
      return e;
  }), r = v(a, null), u = () => {
    S(() => {
      const {
        value: t
      } = f, e = `${t}${o}Rtl`;
      if (d(e, n))
        return;
      const {
        value: c
      } = s;
      c && c.style.mount({
        id: e,
        head: !0,
        anchorMetaName: l,
        props: {
          bPrefix: t ? `.${t}-` : void 0
        },
        ssr: n,
        parent: r == null ? void 0 : r.styleMountTarget
      });
    });
  };
  return n ? u() : R(u), s;
}
export {
  A as useRtl
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-rtl.js
// module id = 44
// module chunks = 41